import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';

import './App.css'
import './css/button.css';
import './css/comman.css';
import './css/toggle.css';
import Home from './container/homes/home';
import Template from './container/tamplate/index.jsx';
import Application from './container/application';
import About from './container/staticPage/about';
import ContactUs from './container/staticPage/ContactUs';
import PrivacyPolicy from './container/staticPage/privacyPolicy';
// import ScrollToTop from './container/dem2';
import FullScreenView from './container/FullScreenView';
import Footer from './components/Footer/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BlogPage from './container/blog/BlogPage';
import BlogPost from './container/blog/BlogPost';
import TawkWidget from './components/chat/TawkWidget';

function App() {
  const [color, setColor] = useState('#FFFF00');
  const [name, setName] = useState('');
  const [speed, setSpeed] = useState(30);
  const [isFlipText, setIsFlipText] = useState(false);
  const [blinkSpeend, setBlinkSpeend] = useState(30);
  const [fontSize, setfontSize] = useState(85);
  const [isblink, setIsblink] = useState(true);
  const [bgColor, setbgColor] = useState('#000000');
  const [RGB, setRGB] = useState({
    r: 92,
    g: 102,
    b: 122
  });

  const callVibrate = () => {
    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  }

  const handlBgcolor = (color) => {
    setbgColor(color);
    const r = parseInt(color.substr(1, 2), 16)
    const g = parseInt(color.substr(3, 2), 16)
    const b = parseInt(color.substr(5, 2), 16)
    setRGB({
      r: r,
      g: g,
      b: b
    });
  }

  const handleSpeedChanger = (val) => {
    setSpeed(val);
  };

  const handleBlinkSpeedChanger = (val) => {
    setBlinkSpeend(val);
  };

  const pluseFonthandler = () => {
    if (isMobile) {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    } else {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    }
  }

  const minusFonthandler = () => {
    if (isMobile) {
      if (fontSize > 12) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    } else {
      if (fontSize > 30) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    }
  }

  const handleBlinkToggle = (e) => {
    setIsblink(!isblink);
  }

  const onCycleComplete = (data) => {
    // Handle cycle completion
  }

  const handleNavigationClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleShareUrl = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Led Scroller",
          text: "Hello! Visit my website to create custom ads and compelling titles for your business. Start promoting your brand today!",
          url: "/",
        })
        .then(() => {
          // console.log("Successfully shared");
        })
        .catch((error) => {
          console.error("Something went wrong", error);
        });
    }
    callVibrate();
  };

  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>LED Scroller - LED Banner | Scrolling Text Generator | Digital Signage Online</title>
          <meta name="description" content="Create free scrolling LED banners and digital signage online. LED Scroller, LED Banner, programmable LED sign, scrolling text generator, digital display board, outdoor and indoor LED signs for business, events, and advertising." />
          <meta name="keywords" content="LED Scroller, LED Banner, scrolling text, digital signage, programmable LED sign, LED display board, scrolling LED sign, digital menu board, outdoor LED sign, indoor LED sign, custom LED sign, free LED text generator, LED message board, digital advertising, electronic sign, running text, LED sign software, cloud-based digital signage, digital display, LED sign for business, LED sign for events, LED sign for shop, multilingual LED sign" />
          <link rel="alternate" href="https://ledscroller.com/" hreflang="en" />
        </Helmet>
        <Routes>
          <Route path="/fullscreen-view" element={
            <FullScreenView
              fontSize={fontSize}
              name={name}
              isMobile={isMobile}
              speed={speed}
              RGB={RGB}
              isblink={isblink}
              blinkSpeend={blinkSpeend}
              isFlipText={isFlipText}
              bgColor={bgColor}
              setName={setName}
              color={color}
              finalResult={{
                name,
                color,
                bgColor,
                speed,
                r: RGB.r,
                g: RGB.g,
                b: RGB.b
              }}
            />
          } />
          <Route path="/*" element={
            <>
              <nav className="main-nav">
                <Link to="/" className="nav-link" onClick={handleNavigationClick}>HOME</Link>
                <Link to="/application" className="nav-link" onClick={handleNavigationClick}>APPLICATION</Link>
                <Link to="/blog" className="nav-link" onClick={handleNavigationClick}>BLOG</Link>
                <Link to="/about" className="nav-link" onClick={handleNavigationClick}>ABOUT US</Link>
                <Link to="/contact" className="nav-link" onClick={handleNavigationClick}>CONTACT US</Link>
                <Link to="/template" className="nav-link" onClick={handleNavigationClick}>TEMPLATE</Link>
              </nav>
              
              <Routes>
                <Route path="/" element={
                  <Home
                    onCycleComplete={onCycleComplete}
                    RGB={RGB}
                    isblink={isblink}
                    speed={speed}
                    setIsFlipText={setIsFlipText}
                    isFlipText={isFlipText}
                    name={name}
                    setName={setName}
                    handleBlinkToggle={handleBlinkToggle}
                    minusFonthandler={minusFonthandler}
                    fontSize={fontSize}
                    pluseFonthandler={pluseFonthandler}
                    color={color}
                    blinkSpeend={blinkSpeend}
                    setColor={setColor}
                    bgColor={bgColor}
                    handlBgcolor={handlBgcolor}
                    handleShareUrl={handleShareUrl}
                    handleSpeedChanger={handleSpeedChanger}
                    handleBlinkSpeedChanger={handleBlinkSpeedChanger}
                  />
                } />
                <Route path="/template" element={<Template />} />
                <Route path="/application" element={<Application />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/fullscreen" element={<FullScreenView />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
      <TawkWidget propertyId="68e24634d59487194ef37545" pageId="1j6pu4fnn" />
    </Router>
  );
}

export default App;
